<template>
<div>

    <div v-if="items" class="animate__animated animate__fadeIn mt-3 historyTest">

        <div class="row ">
            <div class="col-12" v-for="item in items" :key="item.test_id">

                <v-card class="mx-auto " elevation="1">

                    <v-card-text class="pa-2">

                        <div class="row">
                            <div class="col-sm-2  text-center">
                                <div v-if="item.type=='pre'" class="itemPretest">PRE TEST</div>
                                <div v-if="item.type=='post'" class="itemPosttest">POST TEST</div>
                            </div>
                            <div class="col-sm-10">
                                <div class="itemTitle">{{item.title}}</div>
                                <div class="mt-2">
                                    <span>จำนวน {{item.total_question}} ข้อ</span>
                                    <span>ได้ {{item.total_point}} คะแนน</span>
                                    <span>วันที่สอบ {{item.start_test}} </span>
                                </div>
                            </div>
                        </div>

                    </v-card-text>
                </v-card>

            </div>
        </div>

    </div>

    <div class="pg">
        <Paginator v-if="totalItemsCount>0" :rows="12" :totalRecords="totalItemsCount" @page="onPage($event)"></Paginator>
    </div>
</div>
</template>

<script>
export default {

    components: {

    },

    data: () => ({

        totalItemsCount: 0,

        page: 0,
        items: null,

    }),

    computed: {

    },

    watch: {

    },
    methods: {

        getItems() {

            let url = "account/historyTest";

            this.$FULL_LOADING = true
            let $vm = this;

            this.$API
                .post(url, $vm.formData())
                .then(function (res) {
                    $vm.checkApi(res)
                    $vm.totalItemsCount = res.data.total
                    $vm.items = res.data.items

                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        onPage(event) {
            this.page = event.page + 1
            this.getItems()
            this.setPageNo(this.page)

        },

    },
    created() {

        if (this.pageNo) {
            this.page = this.pageNo
        }

        this.getItems();

    },
};
</script>
